import m, {Vnode} from "mithril";
import {CellItem} from "../cellItem";
import {XmlTagInfo} from "../../xmlTagProvider";
import {DragSourceItem} from "./dragSourceItem";
import {DragGroup} from "../../groups/dragGroup";
import Cell from "../../form/cell";
import {Form} from "../../form/form";
import {Questionary} from "../../questionary";
import {Point} from "../../utils";
import {DragItemView} from "../../../ui/items/dragdrop/dragItemView";
import {DragValueView} from "../../../ui/items/dragdrop/dragValueView";

export class DragValue {
    location: DragItem;
    private _parent: DragSourceItem;

    static clone(dv: DragValue): DragValue {
        const cloned = new DragValue(dv.parent);
        cloned.location = dv.location;
        return cloned;
    }

    constructor(parent: DragSourceItem) {
        this._parent = parent;
        this.location = parent;
    }

    set(dragItem: DragItem) {
        // console.log("set", this, this.parent.value, dragItem.cell.id);
        this.location = dragItem;
        dragItem.set(this.value());
    }

    get parent(): DragSourceItem {
        return this._parent;
    }

    reset() {
        // console.log("reset", this, this.parent.value);
        this.location = this._parent;
        this.group().notifyDragValueReset(this);
    }

    getView() {
        // @ts-ignore
        return m(DragValueView.component, {dragValue: this});
    }

    value() {
        return this._parent.value;
    }

    emitDragEvent(name: string, p: Point) {
        this.group().events.emitEvent(name, [p, this]);
    }

    private group(): DragGroup {
        return <DragGroup>this._parent.group;
    }
}


export abstract class DragItem extends CellItem {
    protected view!: DragItemView; // set at init()

    private viewFactory = {
        // @ts-ignore // TODO zjistit co se tady děje
        view: (vnode: Vnode) => m(this.view)
    };

    constructor(config: XmlTagInfo) {
        super(config);
    }

    init(questionary: Questionary, form: Form, cell: Cell) {
        super.init(questionary, form, cell);
    }

    get droppedValue(): DragValue {
        return this.dragGroup.getDragValuesTransitive()
            .filter(v => v.location === this)[0];
    }

    set(value: any) { // but do nothing MUHEHE
        // this.variable(value);
        // this.form.reValidate();
    }

    protected registerEvents(g: DragGroup) {
        g.events.on(DragGroup.Events.DRAG_START, (p: Point) => {
            this.view.canAccept = true;
        });
        g.events.on(DragGroup.Events.DRAG_DROP, (p: Point, dragItem: DragValue) => {
            if (this.view.hit(p)) {
                this.onDrop(dragItem);
            }
            this.view.canAccept = false;
            this.view.hover = false;
        });

        g.events.on(DragGroup.Events.DRAG_MOVE, (p: Point) => {
            this.view.hover = this.view.hit(p);
        });
    }

    getView() {
        return m(this.viewFactory);
    }

    onDrop(dv: DragValue) {
        this.dragGroup.handleDrop(this, dv);
    }

    get dragGroup() {
        return <DragGroup>this.group;
    }

    createDragValue(): DragValue|null {
        return null;
    }

}